"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreemapDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableTreemap_1 = require("./PluggableTreemap");
var BigChartDescriptor_1 = require("../BigChartDescriptor");
var drillDownUtil_1 = require("../drillDownUtil");
var TreemapDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(TreemapDescriptor, _super);
    function TreemapDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TreemapDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableTreemap_1.PluggableTreemap(params); };
    };
    TreemapDescriptor.prototype.applyDrillDown = function (source, drillDownContext) {
        var withFilters = this.addFilters(source, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    TreemapDescriptor.prototype.addFilters = function (source, drillConfig, event) {
        var cutIntersection = drillDownUtil_1.reverseAndTrimIntersection(drillConfig, event.drillContext.intersection);
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection);
    };
    return TreemapDescriptor;
}(BigChartDescriptor_1.BigChartDescriptor));
exports.TreemapDescriptor = TreemapDescriptor;
//# sourceMappingURL=TreemapDescriptor.js.map